import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { parseURLParams } from '@offerzen/pinata-shame'

import browserHistory from '@/CandidateExperience/config/browserHistory'
import { updateQueryParams } from '@/CandidateExperience/helpers/historyHelpers'

const useJobSearchState = () => {
  const { search: URLSearchParams } = useLocation()
  const [searchTerms, setSearchTerms] = useState(() => parseURLParams(URLSearchParams).search)

  return {
    searchTerms,
    setSearchTerms: newSearchTerms => {
      setSearchTerms(newSearchTerms)
      browserHistory.replace({ search: updateQueryParams(URLSearchParams, { search: newSearchTerms, page: 1 }) })
    },
  }
}

export default useJobSearchState
